import { ProductCatalogAttributeSelectionType } from '@graphql/generated-base';
import type { CatalogProductListFilters } from '../Catalog.types';

/**
 * Consolidate Price Range and Price Bucket into one single filter element,
 * since it's represented by one single refinement facet
 * @param filters CatalogProductListFilters
 * @returns CatalogProductListFilters
 */
export const filterConsolidatedPriceList = (filters: CatalogProductListFilters) => {
  return filters.reduce((acc, filter) => {
    const { filterSelectionType } = filter.attributeGroup;
    switch (filterSelectionType) {
      /**
       * If it's priceRange, then keep selectedPriceRange values
       */
      case ProductCatalogAttributeSelectionType.priceRange: {
        const previousPriceFilter = acc.findIndex(filter => filter.attributeGroup.filterSelectionType === ProductCatalogAttributeSelectionType.priceRange);
        if (previousPriceFilter === -1) {
          acc.push(filter);
          return acc;
        }
        acc[previousPriceFilter] = {
          ...acc[previousPriceFilter],
          selectedPriceRange: filter.selectedPriceRange,
        };
        return acc;
      }
      /**
       * If it's priceBucket, then keep the attributes
       */
      case ProductCatalogAttributeSelectionType.priceBucket: {
        const previousPriceFilter = acc.findIndex(filter => filter.attributeGroup.filterSelectionType === ProductCatalogAttributeSelectionType.priceRange);
        if (previousPriceFilter === -1) {
          acc.push({ ...filter, attributeGroup: { ...filter.attributeGroup, filterSelectionType: ProductCatalogAttributeSelectionType.priceRange } });
          return acc;
        }
        acc[previousPriceFilter] = {
          ...acc[previousPriceFilter],
          attributes: filter.attributes,
        };
        return acc;
      }

      default:
        acc.push(filter);
        return acc;
    }
  }, [] as CatalogProductListFilters);
};
